export const daysCountWeeklyNotification = 1;
export const weeklyOverdueTicketsMailValue = [1];
